import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faRightFromBracket,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

interface LogoutGroupUsersModalProps {
  show: boolean;
  onLogoutNow: () => void;
  onLogoutLater: () => void;
  groupName: string;
}

const LogoutGroupUsersModal: React.FC<LogoutGroupUsersModalProps> = ({
  show,
  onLogoutNow,
  onLogoutLater,
  groupName,
}) => {
  return (
    <Modal
      show={show}
      onHide={onLogoutLater}
      centered
      className="fade"
      size="lg"
    >
      <Modal.Header className="border-0 pb-0">
        <div className="d-flex justify-content-center w-100">
          <div className="rounded-circle bg-primary bg-opacity-10 p-3 mb-3">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="text-primary fa-2x"
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pt-0">
        <h4 className="mb-3">Atualização de Grupo</h4>
        <p className="mb-4 ">
          Você modificou o grupo <strong>{groupName}</strong>. Deseja deslogar todos os usuários
          que estão utilizando este grupo para que as alterações tenham efeito imediato?
        </p>
        <div className="d-flex justify-content-center mb-4">
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onLogoutNow}
          >
            <div
              className="rounded-circle bg-danger bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-danger fa-lg"
              />
            </div>
            <h6 className="mb-1">Deslogar Usuários</h6>
            <small className="text-muted">
              Aplicar mudanças imediatamente
            </small>
          </div>
          <div
            className="border rounded p-3 mx-2 text-center"
            style={{ width: "45%", cursor: "pointer" }}
            onClick={onLogoutLater}
          >
            <div
              className="rounded-circle bg-secondary bg-opacity-10 p-2 mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faClock}
                className=" fa-lg"
              />
            </div>
            <h6 className="mb-1">Manter Conectados</h6>
            <small className="text-muted">Usuários só verão mudanças ao fazer login novamente</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 d-flex justify-content-center">
        <small className="text-muted text-center">
          Nota: Os usuários que estão ativamente usando o sistema serão desconectados e precisarão fazer login novamente.
        </small>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutGroupUsersModal;
